import React, { Component } from 'react';
import event1 from '../../img/event-1.jpg'
import event2 from '../../img/event-2.jpg'
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import ReactHtmlParser from 'react-html-parser';
import HtmlParser from 'react-html-parser';
import { FaCalendarAlt, FaMapMarkerAlt, FaUser, FaGlobe, FaHeart, FaUsers, FaStar, FaHandHoldingHeart, FaComment, FaShare, FaBookmark, FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import Zoom from 'react-reveal/Zoom';

class Eventdetails extends Component {
    constructor(props){
        super();
        this.state={
            myeventdetailsid: props.id,
            eventtitle:"...",
             eventimage:"...",
             event_description:"...",
        }
    }

    componentDidMount(){          
        IRestClient.GetRequest(AppUrl.Eventsdetails+this.state.myeventdetailsid).then(result=>{
            this.setState({
             eventtitle:result[0]['event_title'],
             eventimage:result[0]['event_image'],
             event_description:result[0]['event_description'],

                 });
       }) 
  }

    // Function to get event category icon and color (matching Event component)
    getEventStyle = (eventTitle) => {
        const title = eventTitle.toLowerCase();
        if (title.includes('fundraiser') || title.includes('donation')) 
            return { icon: FaHeart, color: 'from-red-500 to-pink-600', bgColor: 'from-red-50 to-pink-100' };
        if (title.includes('volunteer') || title.includes('help')) 
            return { icon: FaUsers, color: 'from-blue-500 to-cyan-600', bgColor: 'from-blue-50 to-cyan-100' };
        if (title.includes('awareness') || title.includes('education')) 
            return { icon: FaGlobe, color: 'from-green-500 to-emerald-600', bgColor: 'from-green-50 to-emerald-100' };
        if (title.includes('celebration') || title.includes('success')) 
            return { icon: FaStar, color: 'from-yellow-500 to-orange-600', bgColor: 'from-yellow-50 to-orange-100' };
        return { icon: FaHandHoldingHeart, color: 'from-purple-500 to-indigo-600', bgColor: 'from-purple-50 to-indigo-100' };
    };

    render() {
        const { icon: IconComponent, color, bgColor } = this.getEventStyle(this.state.eventtitle);

        return (
            <div style={{
                position: 'relative',
                width: '100%',
                padding: '5rem 0',
                background: 'white',
                overflow: 'hidden'
            }}>
                       
                {/* Main Content Container */}
                <div style={{ 
                    position: 'relative', 
                    zIndex: 10, 
                    maxWidth: '1200px', 
                    margin: '0 auto', 
                    padding: '0 1rem' 
                }}>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem' }}>
                        
                        {/* Main Content */}
                        <div style={{ gridColumn: '1 / -1', maxWidth: '100%' }}>
                            
                            {/* Event Header Card */}
                            <motion.div 
                                style={{ 
                                    background: 'white', 
                                    borderRadius: '2rem', 
                                    padding: '2rem', 
                                    marginBottom: '2rem',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(254, 215, 170, 0.2)'
                                }}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                {/* Event Badge */}
                                <div style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    padding: '0.5rem 1rem',
                                    background: '#EEF1F9',
                                    color: '#1B2B5C',
                                    fontSize: '0.875rem',
                                    fontWeight: '600',
                                    borderRadius: '9999px',
                                    border: '1px solid rgba(27,43,92,0.2)',
                                    marginBottom: '1.5rem'
                                }}>
                                    <IconComponent style={{ marginRight: '0.5rem', color: '#1B2B5C' }} />
                                    Event Details
                                </div>

                                {/* Event Title */}
                                <Zoom top>
                                    <h1 style={{ 
                                        fontSize: 'clamp(2rem, 4vw, 3rem)',
                                        fontWeight: '800',
                                        color: '#1B2B5C',
                                        marginBottom: '1.5rem',
                                        lineHeight: '1.2'
                                    }}>
                                        {this.state.eventtitle}
                                    </h1>
                                </Zoom>

                                {/* Event Meta Info */}
                                <div style={{ 
                                    display: 'flex', 
                                    flexWrap: 'wrap', 
                                    gap: '2rem', 
                                    marginBottom: '2rem',
                                    padding: '1.5rem',
                                    background: '#EEF1F9',
                                    borderRadius: '1rem',
                                    border: '1px solid rgba(27,43,92,0.1)'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <FaCalendarAlt style={{ color: '#2E8B54', fontSize: '1.25rem' }} />
                                        <span style={{ fontWeight: '600', color: '#1B2B5C' }}>Event Date</span>
                                </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <FaMapMarkerAlt style={{ color: '#3DAA6B', fontSize: '1.25rem' }} />
                                        <span style={{ fontWeight: '600', color: '#237A4B' }}>Location</span>
                                </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <FaUsers style={{ color: '#1B2B5C', fontSize: '1.25rem' }} />
                                        <span style={{ fontWeight: '600', color: '#1B2B5C' }}>Community Event</span>
                        </div>
                    </div>
                            </motion.div>

                            {/* Event Image */}
                            <motion.div 
                                style={{ 
                                    background: 'white', 
                                    borderRadius: '2rem', 
                                    overflow: 'hidden', 
                                    marginBottom: '2rem',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
                                }}
                                initial={{ opacity: 0, scale: 0.95 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <img 
                                    src={this.state.eventimage} 
                                    alt={this.state.eventtitle}
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        maxHeight: '500px',
                                        objectFit: 'cover',
                                        display: 'block'
                                    }}
                                />
                            </motion.div>

                            {/* Event Description */}
                            <motion.div 
                                style={{ 
                                    background: 'white', 
                                    borderRadius: '2rem', 
                                    padding: '2.5rem', 
                                    marginBottom: '2rem',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(254, 215, 170, 0.2)'
                                }}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <h2 style={{ 
                                    fontSize: '1.875rem', 
                                    fontWeight: '700', 
                                    color: '#111827', 
                                    marginBottom: '1.5rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.75rem'
                                }}>
                                    <div style={{ 
                                        width: '3px', 
                                        height: '2rem', 
                                        background: 'linear-gradient(to bottom, #2E8B54, #237A4B)',
                                        borderRadius: '2px'
                                    }}></div>
                                    About This Event
                                </h2>
                                
                                <div style={{ 
                                    color: '#4b5563', 
                                    lineHeight: '1.8', 
                                    fontSize: '1.125rem',
                                    textAlign: 'justify'
                                }}>
                                    {HtmlParser(this.state.event_description)}
                                        </div>
                            </motion.div>

                            {/* Action Buttons */}
                            <motion.div 
                                style={{ 
                                    display: 'flex', 
                                    flexWrap: 'wrap', 
                                    gap: '1rem', 
                                    marginBottom: '2rem'
                                }}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <button style={{ 
                                    display: 'inline-flex', 
                                    alignItems: 'center', 
                                    padding: '0.75rem 1.5rem', 
                                    background: 'linear-gradient(to right, #2E8B54, #237A4B)',
                                    color: 'white',
                                    fontWeight: '600',
                                    fontSize: '1rem',
                                    borderRadius: '9999px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                                }}>
                                    <FaShare style={{ marginRight: '0.5rem' }} />
                                    Share Event
                                </button>
                                
                                <button style={{ 
                                    display: 'inline-flex', 
                                    alignItems: 'center', 
                                    padding: '0.75rem 1.5rem', 
                                    background: 'linear-gradient(to right, #1B2B5C, #2D4E96)',
                                    color: 'white', 
                                    fontWeight: '600', 
                                    fontSize: '1rem', 
                                    borderRadius: '9999px', 
                                    border: 'none',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                                }}>
                                    <FaBookmark style={{ marginRight: '0.5rem' }} />
                                    Save Event
                                </button>
                            </motion.div>

                            {/* Comment Form */}
                            <motion.div 
                                style={{ 
                                    background: 'white', 
                                    borderRadius: '2rem', 
                                    padding: '2.5rem',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(254, 215, 170, 0.2)'
                                }}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <h2 style={{ 
                                    fontSize: '1.875rem', 
                                    fontWeight: '700', 
                                    color: '#111827', 
                                    marginBottom: '2rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.75rem'
                                }}>
                                    <FaComment style={{ color: '#2E8B54' }} />
                                    Leave a Comment
                                </h2>
                                
                                <form style={{ display: 'grid', gap: '1.5rem' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
                                        <div>
                                            <label style={{ 
                                                display: 'block', 
                                                fontWeight: '600', 
                                                color: '#374151', 
                                                marginBottom: '0.5rem' 
                                            }}>
                                                Name *
                                            </label>
                                            <input 
                                                type="text" 
                                                style={{ 
                                                    width: '100%', 
                                                    padding: '0.75rem 1rem', 
                                                    border: '2px solid #e5e7eb', 
                                                    borderRadius: '0.75rem', 
                                                    fontSize: '1rem',
                                                    transition: 'all 0.3s ease',
                                                    outline: 'none'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#2E8B54';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(46,139,84,0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                            </div>
                                        
                                        <div>
                                            <label style={{ 
                                                display: 'block', 
                                                fontWeight: '600', 
                                                color: '#374151', 
                                                marginBottom: '0.5rem' 
                                            }}>
                                                Email *
                                            </label>
                                            <input 
                                                type="email" 
                                                style={{ 
                                                    width: '100%', 
                                                    padding: '0.75rem 1rem', 
                                                    border: '2px solid #e5e7eb', 
                                                    borderRadius: '0.75rem', 
                                                    fontSize: '1rem',
                                                    transition: 'all 0.3s ease',
                                                    outline: 'none'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#2E8B54';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(46,139,84,0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                </div>
                            </div>

                                    <div>
                                        <label style={{ 
                                            display: 'block', 
                                            fontWeight: '600', 
                                            color: '#374151', 
                                            marginBottom: '0.5rem' 
                                        }}>
                                            Message *
                                        </label>
                                        <textarea 
                                            rows="5" 
                                            style={{ 
                                                width: '100%', 
                                                padding: '0.75rem 1rem', 
                                                border: '2px solid #e5e7eb', 
                                                borderRadius: '0.75rem', 
                                                fontSize: '1rem',
                                                resize: 'vertical',
                                                transition: 'all 0.3s ease',
                                                outline: 'none',
                                                fontFamily: 'inherit'
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = '#2E8B54';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(46,139,84,0.1)';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = '#e5e7eb';
                                                e.target.style.boxShadow = 'none';
                                            }}
                                        ></textarea>
                            </div>

                                    <button 
                                        type="submit" 
                                        style={{ 
                                            display: 'inline-flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            padding: '0.875rem 2rem', 
                                            background: 'linear-gradient(to right, #2E8B54, #237A4B)',
                                            color: 'white',
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            borderRadius: '9999px',
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                                            alignSelf: 'flex-start'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                                        }}
                                    >
                                        <FaComment style={{ marginRight: '0.5rem' }} />
                                        Post Comment
                                    </button>
                                </form>
                            </motion.div>
                            </div>

                        {/* Sidebar */}
                        <div style={{ 
                            gridColumn: '1 / -1', 
                            maxWidth: '100%',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                            gap: '2rem'
                        }}>
                            
                            {/* Recent Events Widget */}
                            <motion.div 
                                style={{ 
                                    background: 'white', 
                                    borderRadius: '2rem', 
                                    padding: '2rem',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(254, 215, 170, 0.2)'
                                }}
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <h2 style={{ 
                                    fontSize: '1.5rem', 
                                    fontWeight: '700', 
                                    color: '#111827', 
                                    marginBottom: '1.5rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.75rem'
                                }}>
                                    <FaCalendarAlt style={{ color: '#2E8B54' }} />
                                    Recent Events
                                </h2>
                                
                                <div style={{ display: 'grid', gap: '1rem' }}>
                                    {[1, 2, 3].map((item, index) => (
                                        <div key={index} style={{ 
                                            display: 'flex', 
                                            gap: '1rem', 
                                            padding: '1rem', 
                                            background: '#EEF1F9',
                                            borderRadius: '1rem',
                                            border: '1px solid rgba(27,43,92,0.1)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateX(5px)';
                                            e.currentTarget.style.background = '#D4DCEF';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateX(0)';
                                            e.currentTarget.style.background = 'linear-gradient(135deg, #fef3c7 0%, #fef2f2 100%)';
                                        }}>
                                            <img 
                                                src={event1} 
                                                alt="Recent Event" 
                                                style={{ 
                                                    width: '60px', 
                                                    height: '60px', 
                                                    borderRadius: '0.75rem',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div>
                                                <h3 style={{ 
                                                    fontWeight: '600', 
                                                    color: '#111827', 
                                                    marginBottom: '0.25rem',
                                                    fontSize: '0.875rem'
                                                }}>
                                                    Community Outreach Program
                                                </h3>
                                                <p style={{ 
                                                    color: '#6b7280', 
                                                    fontSize: '0.75rem' 
                                                }}>
                                                    Helping local communities
                                                </p>
                                </div>
                            </div>
                                    ))}
                                </div>
                            </motion.div>

                            {/* Image Widget */}
                            <motion.div 
                                style={{ 
                                    background: 'white', 
                                    borderRadius: '2rem', 
                                    padding: '2rem',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(254, 215, 170, 0.2)'
                                }}
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <div style={{ 
                                    borderRadius: '1.5rem', 
                                    overflow: 'hidden',
                                    border: '1px solid rgba(254, 215, 170, 0.2)'
                                }}>
                                    <img 
                                        src={event2} 
                                        alt="Event Image" 
                                        style={{ 
                                            width: '100%', 
                                            height: 'auto',
                                            display: 'block'
                                        }}
                                    />
                        </div>
                            </motion.div>

                            {/* Quote Widget */}
                            <motion.div 
                                style={{ 
                                    background: '#EEF1F9', 
                                    borderRadius: '2rem', 
                                    padding: '2rem',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(251, 191, 36, 0.3)'
                                }}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <h2 style={{ 
                                    fontSize: '1.25rem', 
                                    fontWeight: '700', 
                                    color: '#1B2B5C',
                                    marginBottom: '1rem',
                                    textAlign: 'center'
                                }}>
                                    Even the smallest gift can change one's life
                                </h2>
                                <p style={{
                                    color: '#1B2B5C',
                                    lineHeight: '1.6',
                                    textAlign: 'center',
                                    fontSize: '0.875rem'
                                }}>
                                    SOYAN is committed to not only meet the individual needs but also to develop the local community based on their necessities and culture.
                                </p>
                            </motion.div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default Eventdetails;